/**
 * `/app/work` — the route. The page is `pages/client/work/`.
 *
 * A route file is the address and the guard; the page is the screen. Keeping them
 * apart is what lets a page test mount the page over the recorded world without the
 * router's own tree (`test/clientPage.tsx`), and it is why every one of these is
 * four lines.
 *
 * No `validateSearch`: the page's whole question is "what is in flight for me", the
 * cursor lives in the query cache rather than in the address, and there is nothing
 * here for a reader to filter or for the back button to restore.
 */

import { createFileRoute } from '@tanstack/react-router'

import { WorkPage } from '../../pages/client/work/WorkPage.js'

export const Route = createFileRoute('/app/work')({
  component: WorkPage,
})
